<div
    class="kh-field-point-boundary"
    [ngClass]="{
        active: !isHighlighted,
        highlighted: isHighlighted,
        small: size === fieldPointIconsSize.Small,
        medium: size === fieldPointIconsSize.Medium,
    }"
    [ngStyle]="getColorStyle()"
    (mouseenter)="hover()"
    (mouseleave)="hoverOut()"
    (click)="click()"
>
    <span
        class="material-symbols-outlined kh-field-point-icon"
        [ngStyle]="getFontColor()"
        >{{ iconName }}</span
    >
</div>

<ng-container #infoWindowContainer></ng-container>
